// CATEGORIES
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_FAIL = "GET_NOTIFICATIONS_FAIL";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
// blue tick
export const BLUE_TICK_NOTIFICATIONS = "BLUE_TICK_NOTIFICATIONS";
export const BLUE_TICK_NOTIFICATIONS_FAIL = "BLUE_TICK_NOTIFICATIONS_FAIL";
export const BLUE_TICK_NOTIFICATIONS_SUCCESS =
  "BLUE_TICK_NOTIFICATIONS_SUCCESS";

// art notification 
export const GET_ART_NOTIFICATION_REQUEST = "GET_ART_NOTIFICATION_REQUEST";
export const GET_ART_NOTIFICATION_FAIL = "GET_ART_NOTIFICATION_FAIL";
export const GET_ART_NOTIFICATION_SUCCESS =
  "GET_ART_NOTIFICATION_SUCCESS";

// update art notification 
export const UPDATE_ARTNOTIFICATION_REQUEST = "PUT_ARTNOTIFICATION_REQUEST";
export const UPDATE_ARTNOTIFICATION_FAIL = "PUT_ARTNOTIFICATION_FAIL";
export const UPDATE_ARTNOTIFICATION_SUCCESS = "PUT_ARTNOTIFICATION_FAIL";


// post notification 
export const POST_NOTIFICATION_REQUEST = "POST_NOTIFICATION_REQUEST";
export const POST_NOTIFICATION_FAIL = "POST_NOTIFICATION_FAIL";
export const POST_NOTIFICATION_SUCCESS = "POST_NOTIFICATION_SUCCESS";

// newsletter 
export const SEND_NEWSLETTER_EMAIL_REQUEST = "SEND_NEWSLETTER_EMAIL_REQUEST";
export const SEND_NEWSLETTER_EMAIL_FAIL = "SEND_NEWSLETTER_EMAIL_FAIL";
export const SEND_NEWSLETTER_EMAIL_SUCCESS = "SEND_NEWSLETTER_EMAIL_SUCCESS";

export const ADD_NEWSLETTER_EMAIL_REQUEST = "ADD_NEWSLETTER_EMAIL_REQUEST";
export const ADD_NEWSLETTER_EMAIL_FAIL = "ADD_NEWSLETTER_EMAIL_FAIL";
export const ADD_NEWSLETTER_EMAIL_SUCCESS = "ADD_NEWSLETTER_EMAIL_SUCCESS";